import client from '../client';
import { Account } from '../media';

export const list = (product: Account['product']) =>
  client.get<Account[]>(`/accounts?product=${product}`).then(resp => resp.data);
